import "./App.css";
import { Link as RouterLink } from "react-router-dom";
import { BiWorld } from "react-icons/bi";
import MarProfile from "./images/mar_profile_new.JPG";
import ConsultBookingForm from "./ConsultBookingForm";

function ConsultsForClinicians() {
  return (
    <div className="App">
      <div className="header-container">
        <header>
          <RouterLink to="/" style={{ textDecoration: "none", color: "inherit" }}>
            <h1>
              <BiWorld
                style={{ height: "40px", width: "40px", color: "white" }}
              />
            </h1>
          </RouterLink>
          <div className="header-links-container">
            <RouterLink to="/" className="header-links">
              Back to Home
            </RouterLink>
          </div>
        </header>
      </div>
      <div className="banner">
        <h1>Immigration Evaluation Consults for Clinicians</h1>
      </div>
      <div className="about-me">
        <div className="image">
          <img src={MarProfile} alt="Marissa" />
        </div>
        <div className="bio">
          <div className="approach-beliefs">
            <div>
              <p>
                Providing immigration evaluations can be meaningful work—but it's not for every practice, and it comes with real clinical, logistical, and emotional demands. I offer consultation for therapists seeking mentorship around entering or refining immigration evaluation work. Topics include getting started, marketing and building referral relationships, managing time and documentation, evaluating fit with your current caseload, handling difficult or high-stakes cases, and avoiding common pitfalls. My goal is to help you make informed, grounded decisions and build a practice that is both ethical and sustainable.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="contact-section-container">
        <div className="contact-section" id="consult-booking-form">
          <div>
            <h3>Request a Consultation</h3>
            <p>
              Interested in learning more about immigration evaluation work? Please fill out the form below and I'll get back to you to schedule a consultation.
            </p>
          </div>
          <ConsultBookingForm />
        </div>
        <div className="contact-section" style={{ flexDirection: "column", alignItems: "center", padding: "40px 32px" }}>
          <RouterLink to="/" className="header-links">
            Back to Home
          </RouterLink>
        </div>
      </div>
    </div>
  );
}

export default ConsultsForClinicians;

